export default <Target extends Record<string, any>>(
  methods: Array<keyof Target>,
) => {
  let setTarget: (value: Target) => void | undefined
  const target = new Promise<Target>(resolve => (setTarget = resolve))

  return {
    setTarget: setTarget!,
    proxy: methods.reduce(
      (proxy, method) =>
        Object.assign(proxy, {
          [method]: async (...args: unknown[]) =>
            (await target)[method](...args),
        }),
      {} as Target,
    ),
  }
}
